import React from "react";
import outline from "../../assets/icons/qualification-vector-2.svg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const HomeStats = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });
  return (
    <div className=" xl:py-28 lg:py-20 md:py-14 py-10 relative bg-matcha">
      <div className=" bottom-0 right-0 absolute">
        <img src={outline} alt="outline" />
      </div>
      <div data-aos="fade-up" className="xl:w-[1280px] w-11/12 mx-auto flex justify-center items-center flex-col z-10">
        <span className="text-xl font-medium text-[#1d9e75] uppercase border-b border-[#B87333] px-2 py-1.5 ">
          Clinical Experience
        </span>
        <h2 className="lg:text-4xl md:text-3xl text-xl text-center font-bold mt-2 text-white leading-tight px-8">
          Precision in Treatment, Compassion in Care
        </h2>
        <div className="grid md:grid-cols-2 xl:grid-cols-4 grid-cols-1 w-full xl:gap-20 md:gap-10 gap-8 xl:mt-24 lg:mt-20 md:mt-16 mt-12">
          <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="w-full relative flex justify-center flex-col gap-4 items-center"
          >
            <div className="flex flex-row justify-center items-center gap-4">
              <div
                ref={ref}
                className="md:text-7xl text-6xl font-extrabold  flex outline-text justify-center items-center w-full"
              >
                {inView ? <CountUp end={15} duration={2} separator="" /> : null}
                +
              </div>
            </div>
            <h3 className="z-10 text-2xl font-bold text-[#1d9e75]">
              Years of Experience
            </h3>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="w-full relative flex justify-center flex-col gap-4 items-center"
          >
            <div className="flex flex-row justify-center items-center gap-4">
              <div
                ref={ref}
                className="md:text-7xl text-6xl font-extrabold text-[#F7F6F9]  flex outline-text justify-center items-center w-full"
              >
                {inView ? <CountUp end={5} duration={2} separator="" /> : null}
                K+
              </div>
            </div>
            <h3 className="z-10 text-2xl font-bold text-[#1d9e75]">
              Patients Treated
            </h3>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="w-full relative flex justify-center flex-col gap-4 items-center"
          >
            <div className="flex flex-row justify-center items-center gap-4">
              <div
                ref={ref}
                className="md:text-7xl text-6xl font-extrabold text-[#F7F6F9]  outline-text flex justify-center items-center w-full"
              >
                {inView ? (
                  <CountUp end={100} duration={2} separator="" />
                ) : null}
                +
              </div>
            </div>
            <h3 className="z-10 text-2xl font-bold text-[#1d9e75]">Surgeries</h3>
          </div>
          <div
            data-aos="fade-up"
            data-aos-delay="100"
            className="w-full relative flex justify-center flex-col gap-4 items-center"
          >
            <div className="flex flex-row justify-center items-center gap-4">
              
              <div
                ref={ref}
                className="md:text-7xl text-6xl font-extrabold text-[#F7F6F9]  outline-text flex justify-center items-center w-full"
              >
                {inView ? <CountUp end={98} duration={2} separator="" /> : null}
                %
              </div>
            </div>
            <h3 className="z-10 text-2xl font-bold text-[#1d9e75]">Satisfaction</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeStats;
